import { jsx } from 'react/jsx-runtime';
import { CodeSnippet } from '@backstage/core-components';
import { useTheme } from '@material-ui/core/styles';

const GrpcApiDefinitionWidget = (props) => {
  const theme = useTheme();
  return /* @__PURE__ */ jsx(
    CodeSnippet,
    {
      customStyle: { backgroundColor: theme.palette.background.default },
      text: props.definition,
      language: "protobuf",
      showCopyCodeButton: true
    }
  );
};

export { GrpcApiDefinitionWidget };
//# sourceMappingURL=GrpcApiDefinitionWidget.esm.js.map
